module.exports = __webpack_public_path__ + "img/dial3.6a6a6dcc.png";